import { NavigationMegaMenuCellLinkEntityHydrated } from "@jackfruit/common"
import React, { useState } from "react"
import { usePage } from "~/hooks/usePage"
import { Badge, HStack, Link as ChakraLink, Text } from "@chakra-ui/react"
import { Link as GatsbyLink } from "gatsby"

interface Props {
  link: NavigationMegaMenuCellLinkEntityHydrated
  to?: string
}

const FooterBlockMegamenuLink: React.FC<Props> = ({ link }) => {
  const { external: isExternal, badgeText, badgeColor } = link
  const hasBadge = Boolean(badgeText)
  const isPageLink = link.type === "page"
  const { page } = usePage(link.pageId)
  let to = isPageLink ? page?.path : link.path

  if (!to) {
    to = "/"
  }

  let linkComponent = isExternal ? (
    <ExternalLink link={link} to={to} />
  ) : (
    <InternalLink link={link} to={to} />
  )

  let badge = null
  if (hasBadge) {
    badge = (
      <Badge
        size="xs"
        backgroundColor={badgeColor}
        textColor="white"
        borderRadius="md"
        textTransform="none"
      >
        {badgeText}
      </Badge>
    )
  }

  return (
    <HStack>
      {linkComponent}
      {badge}
    </HStack>
  )
}

export default FooterBlockMegamenuLink

const InternalLink: React.FC<Props> = ({ link, to = "" }) => {
  const { label } = link
  const [isHovering, setIsHovering] = useState(false)

  const handleMouseEnter = () => {
    setIsHovering(true)
  }

  const handleMouseLeave = () => {
    setIsHovering(false)
  }

  return (
    <GatsbyLink
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      to={to}
      activeStyle={{
        textDecoration: "underline",
      }}
      style={{
        textDecoration: isHovering ? "underline" : "none",
      }}
    >
      {label}
    </GatsbyLink>
  )
}

const ExternalLink: React.FC<Props> = ({ link, to = "" }) => {
  const { label } = link
  return (
    <ChakraLink
      id={`mega-menu-link-${link.id}`}
      href={to}
      isExternal={true}
      onClick={() => {
        window.open(to, "newWindow")
      }}
      _hover={{
        textDecoration: "underline",
      }}
    >
      {label}
    </ChakraLink>
  )
}
